import React, { FC } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { DeviceTimePattern } from "../../../models/DeviceTimePattern";

interface WizardSummaryProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    selectedDeviceTimePattern: DeviceTimePattern;
    selectedMode: any
}

export const WizardSummary: FC<WizardSummaryProps> = ({ onNext = undefined, onBack = undefined, selectedDeviceTimePattern, selectedMode }) => {
    const { translate } = useLocale();

    return <div className="flex flex-col pt-3 pr-3 h-full relative" style={{ height: "501px" }}>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.mode)}: <span className="text-sm text-black">{selectedMode.name}</span></h4>
        <br />
        <h2 className="p-1 text-lg font-bold">{translate.byKey(TranslationKeys.activePeriod)}</h2>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.timePattern)}: <span className="text-sm text-black">{selectedDeviceTimePattern.name}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.startDate)}: <span className="text-sm text-black">{selectedDeviceTimePattern.startDate === "" ? '----' : selectedDeviceTimePattern.startDate}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.endDate)}: <span className="text-sm text-black">{selectedDeviceTimePattern.endDate === "" ? '----' : selectedDeviceTimePattern.endDate}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.startTime)}: <span className="text-sm text-black">{selectedDeviceTimePattern.startTime ?? '--:--'}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.endTime)}: <span className="text-sm text-black">{selectedDeviceTimePattern.endTime ?? '--:--'}</span></h4>
        <h4 className="p-1 text-xs text-gray-600">{translate.byKey(TranslationKeys.days)}: <span className="text-sm text-black">{selectedDeviceTimePattern.days}</span></h4>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={e => {
                        if (onBack)
                            onBack(e);
                    }}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary secondary-enabled`}
                    type={false ? 'button' : 'submit'}
                    onClick={onNext ? (e) => onNext(e) : () => { }}>{translate.byKey(TranslationKeys.confirm)}</button>
            </div>
        </div>
    </div>;
};
